/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import DocumentUploadPreview from '../DocumentUploadPreview/DocumentUploadPreview';

import {
  frameworkDocuments,
  frameworkTypes
} from './Constants/Documents/ESGConstants';
import {
  AIDocumentManagerKey,
  AIDocumentManagerLabel
} from './Constants/IP/AIDocumentManagerLabel';
import {yearKeyLabel} from './Constants/IP/commonKeyLabel';

const ESGDocumentManagerForm: React.FC<{
  currentStep?: number;
}> = ({currentStep}) => {
  const FormInstance = useFormInstance();

  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();

  const docTypeFromParam = searchParam.get('frameworkDocumentType');
  const initialDocType =
    docTypeFromParam &&
    docTypeFromParam !== 'all' &&
    frameworkDocuments.some(
      (doc) => doc.framework === 'BRSR' && doc.value === docTypeFromParam
    )
      ? docTypeFromParam
      : undefined;

  return (
    <>
      {currentStep === 0 && (
        <>
          {/* YEAR */}
          <Col className="gutter-row">
            <Form.Item
              name={AIDocumentManagerKey.YEAR}
              label={AIDocumentManagerLabel.YEAR}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(AIDocumentManagerLabel.YEAR)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={yearFilter}
                suffixIcon={<YearCalender />}
              />
            </Form.Item>
          </Col>

          {/* FRAMEWORK */}
          <Col className="gutter-row">
            <Form.Item
              name={AIDocumentManagerKey.BILL_TYPE}
              label={AIDocumentManagerLabel.FRAMEWORK}
              labelCol={{span: 24}}
              initialValue={'BRSR'}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(
                    AIDocumentManagerLabel.FRAMEWORK
                  )
                }
              ]}
              validateFirst
            >
              <Select
                className="select"
                placeholder={`Choose ${AIDocumentManagerLabel.FRAMEWORK}`}
                options={frameworkTypes}
                disabled={true}
                onChange={() => {
                  // Reset document type + validation
                  FormInstance.setFields([
                    {
                      name: AIDocumentManagerKey.DOCUMENT_TYPE,
                      value: undefined
                    }
                  ]);
                }}
              />
            </Form.Item>
          </Col>

          {/* DOCUMENT TYPE */}
          <Col className="gutter-row">
            <Form.Item
              shouldUpdate={(prev, curr) =>
                prev[AIDocumentManagerKey.BILL_TYPE] !==
                curr[AIDocumentManagerKey.BILL_TYPE]
              }
              noStyle
            >
              {({getFieldValue}) => {
                const framework = getFieldValue(AIDocumentManagerKey.BILL_TYPE);

                const docTypes = frameworkDocuments.filter(
                  (item) => item.framework === framework
                );

                return (
                  <Form.Item
                    name={AIDocumentManagerKey.DOCUMENT_TYPE}
                    label={AIDocumentManagerLabel.DOCUMENT_TYPE}
                    labelCol={{span: 24}}
                    initialValue={initialDocType}
                    rules={[
                      {
                        required: true,
                        message: CommonErrors.mandatory(
                          AIDocumentManagerLabel.DOCUMENT_TYPE
                        )
                      }
                    ]}
                  >
                    <Select
                      className="select"
                      placeholder={`Choose ${AIDocumentManagerLabel.DOCUMENT_TYPE}`}
                      options={docTypes}
                      disabled={!framework}
                      showSearch={true}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>

            <Form.Item name={'type'} initialValue={'ESG'} hidden />
          </Col>
        </>
      )}

      {/* STEP 2 */}
      {currentStep === 1 && (
        <>
          <Col className="gutter-row">
            <Form.Item noStyle shouldUpdate>
              <DocumentUploadPreview
                formInstance={FormInstance}
                validationMessage="Please upload document"
              />
            </Form.Item>
            <Form.Item name="file_name" hidden />
          </Col>
        </>
      )}
    </>
  );
};

export default ESGDocumentManagerForm;
